<template>
  <div>
    <p>Please ask the child:</p>
    <doe-label v-if="label" :name="name" size="large">
      "{{ label }}"
    </doe-label>
    <input
      type="text"
      :name="name"
      :id="name"
      :value="value"
      :placeholder="placeholder"
      :aria-describedby="hint ? ariaDescID : false"
      @input="$emit('input', $event.target.value)"
    />
    <doe-hint :hint="hint" :description="ariaDescID" />
    <doe-button
      @click.prevent
      class="mt-4"
      appearance="secondary"
      size="medium"
      prefix="plus"
    >
      Add response
    </doe-button>
  </div>
</template>

<script>
import DoeLabel from "@/components/field/Label";
import DoeHint from "@/components/field/Hint";
import DoeButton from "@/components/button/Button";

export default {
  name: "DoeRepeater",
  props: {
    name: {
      type: String,
      required: true
    },
    value: {
      type: String
    },
    label: {
      type: String,
      required: true
    },
    placeholder: {
      type: String
    },
    hint: {
      type: [Array, String]
    }
  },
  components: {
    DoeLabel,
    DoeHint,
    DoeButton
  },
  computed: {
    ariaDescID() {
      return `${this.name}Description`;
    }
  }
};
</script>

<style lang="scss" scoped>
p {
  @apply font-sans mb-1;
}
input {
  @apply block bg-gray-300 border border-gray-800 rounded font-sans leading-snug max-w-2xl px-3 py-2 subpixel-antialiased text-gray-900 text-xl w-full;
  &:hover {
    @apply border-blue-900;
    box-shadow: 0 0 0 1px #041e42;
  }
  &:focus {
    @apply border-blue-900;
    box-shadow: 0 0 0 1px #041e42;
    outline: 1px solid #041e42;
    outline-offset: 3px;
  }
}
</style>
